export default "__VITE_ASSET__201c2305__"